import React from 'react'
import pic from '../../images/icons_assets/underconstruction.svg';
import './underConstruction.css';


const UnderContruction = () => {
  return (
   <main className='underConstruction'>
       <img src={pic} alt='logo' />
   </main>
  )
}

export default UnderContruction